// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteV3ClientGeneratedContactDatePreferenceType } from './siteV3ClientGeneratedContactDatePreferenceType.js';
import type { SiteV3ClientGeneratedContactInformationPurposeType } from './siteV3ClientGeneratedContactInformationPurposeType.js';
import type { SiteV3ClientGeneratedContactTimePreferenceType } from './siteV3ClientGeneratedContactTimePreferenceType.js';
import type { SiteV3ClientGeneratedPhoneContactInformationType } from './siteV3ClientGeneratedPhoneContactInformationType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteV3ClientGeneratedPhoneUpsearchModel {
    'phoneId'?: number | null;
    'phoneType'?: SiteV3ClientGeneratedPhoneContactInformationType;
    'phonePurpose'?: SiteV3ClientGeneratedContactInformationPurposeType;
    'phoneNumber': string;
    'extension': string;
    'contactDatePreferenceType'?: SiteV3ClientGeneratedContactDatePreferenceType;
    'bestDaysToCall': string;
    'contactTimePreferenceType'?: SiteV3ClientGeneratedContactTimePreferenceType;
    'bestTimeToCall': string;
    'language': string;
    'timeZone': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteV3ClientGeneratedPhoneUpsearchModel>> = [
        {
            "name":     "phoneId",
            "baseName": "phoneId",
            "type":     "number"
        },
        {
            "name":     "phoneType",
            "baseName": "phoneType",
            "type":     "SiteV3ClientGeneratedPhoneContactInformationType"
        },
        {
            "name":     "phonePurpose",
            "baseName": "phonePurpose",
            "type":     "SiteV3ClientGeneratedContactInformationPurposeType"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "extension",
            "baseName": "extension",
            "type":     "string"
        },
        {
            "name":     "contactDatePreferenceType",
            "baseName": "contactDatePreferenceType",
            "type":     "SiteV3ClientGeneratedContactDatePreferenceType"
        },
        {
            "name":     "bestDaysToCall",
            "baseName": "bestDaysToCall",
            "type":     "string"
        },
        {
            "name":     "contactTimePreferenceType",
            "baseName": "contactTimePreferenceType",
            "type":     "SiteV3ClientGeneratedContactTimePreferenceType"
        },
        {
            "name":     "bestTimeToCall",
            "baseName": "bestTimeToCall",
            "type":     "string"
        },
        {
            "name":     "language",
            "baseName": "language",
            "type":     "string"
        },
        {
            "name":     "timeZone",
            "baseName": "timeZone",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SiteV3ClientGeneratedPhoneUpsearchModel.attributeTypeMap;
    }
}
